import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationKO from './resource/ko.json';
import translationJA from './resource/ja.json';
import translationEN from './resource/en.json';
import translationZH from './resource/zh.json';
import translationZHHK from './resource/zh-HK.json';
import translationRU from './resource/ru.json';
import translationUZ from './resource/uz.json';

const resources = {
  'ko': {
    translation: translationKO,
  },
  'ja': {
    translation: translationJA,
  },
  'en': {
    translation: translationEN,
  },
  'zh': {
    translation: translationZH,
  },
  'zh-HK': {
    translation: translationZHHK,
  },
  'ru': {
    translation: translationRU,
  },
  'uz': {
    translation: translationUZ,
  },
};

export const initializeI18n = () => {
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources,
      fallbackLng: {
        'default': ['ko'],
        'zh-HK': ['zh-HK', 'en'],
        'ru': ['ru', 'en'],
        'uz': ['uz', 'en'],
      },
      detection: { order: ['path', 'navigator'] },
    })
    .then();
};
